import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectLocationInt = createFeatureSelector<any>('intBranch');

export const selectLocationIntState = createSelector(
    selectLocationInt,
    (state: any) => state,
);
